import React, { useState } from "react"
import { Box, Dialog, DialogContent, IconButton } from "@material-ui/core"
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined"
import styled from "styled-components"
import { InfoContent } from "./InfoContent"

const Wrap = styled.div`
  position: absolute;
  left: 5px;
  top: 5px;
`

const Button = styled(IconButton)`
  background-color: ${props => props.bgc};
  padding: 5px;
`

export const InfoButton = props => {
  const [isOpen, setIsOpen] = useState(false)
  const buttonIconColor =
    props?.gameData?.game_info_popup?.button_icon_color || "rgba(0,0,0,0.8)"
  const buttonBackgroundColor =
    props?.gameData?.game_info_popup?.button_background_color ||
    "rgba(255,255,255,0.5)"
  const buttonTitle =
    props?.gameData?.game_info_popup?.button_hover_text || "Info"

  const handleClick = () => {
    if (props.onClick) {
      props.onClick()
      return
    }
    setIsOpen(!isOpen)
  }

  return (
    <>
      <Wrap>
        <Button
          onClick={handleClick}
          bgc={buttonBackgroundColor}
          title={buttonTitle}
        >
          <InfoOutlinedIcon htmlColor={buttonIconColor} />
        </Button>
      </Wrap>
      <Dialog
        open={isOpen}
        onClose={() => setIsOpen(false)}
        fullWidth
        maxWidth="md"
      >
        <InfoContent {...props} onClose={() => setIsOpen(false)} />
      </Dialog>
    </>
  )
}
